module.exports = __webpack_public_path__ + "img/home-insurance.83fadae.png";